export enum USER_TYPES {
  GERENTE = 'gerente',
  PILOTO = 'vendedor',
  SUPERVISOR = 'supervisor',
  JEFE = 'jefe',
  AGENCIA = 'agencia',
  ESCUDERIA = 'escuderia',
  SUPER_ADMIN = 'super_admin'
}

export enum ESCUDERIAS {
  AUSTRO_SIERRA = 'austrosierra',
  SUR = 'sur',
  NORTE = 'norte'
}

export const ESCUDERIAS_IMAGES = {
  [ESCUDERIAS.AUSTRO_SIERRA]: 'https://superlikers-themes.s3.us-east-1.amazonaws.com/toniclub/logos/Logo+Austro+sierra.png',
  [ESCUDERIAS.SUR]: 'https://superlikers-themes.s3.us-east-1.amazonaws.com/toniclub/logos/LogoSur.png',
  [ESCUDERIAS.NORTE]: 'https://superlikers-themes.s3.us-east-1.amazonaws.com/toniclub/logos/LogoNorte.png'
}

export interface User {
  uid: string
  authenticated: boolean | null
  avatar: string
  name: string
  email: string
  cargo: string | null
  totalUsers: number | null
  tags: string[]
  userType: USER_TYPES
  points: number
  unconfirmed_email: string
  celular: string
  numero_de_documento: string
  update_file: boolean
  total_points: number
  ruta: string
  escuderia: {
    name: string
    tag: string
    image: string
  }
  agencia: {
    name: string
    tag: string
  }
  zona: {
    name: string
    tag: string
  }
}
